// Centered card for unauthenticated screens (spec §77).
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
        {children}
        {footer ? (
          <div style={{ marginTop: 16, fontSize: 14, color: 'var(--color-text-muted)' }}>
            {footer}
          </div>
        ) : null}
        <div style={{ marginTop: 24, fontSize: 12, color: 'var(--color-text-muted)' }}>
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
